import { deleteRequest, getRequest, postRequest, putRequest } from '@bo-apis/axios';

const getSiteMgmtList = (skip = {}) =>
  getRequest(
    {
      url: `/api/v1/system/site/get-site-mgmt-list`,
    },
    skip
  );

const getAllSiteSimpleList = (skip = {}) =>
  getRequest(
    {
      url: `/api/v1/system/site/get-all-site-simple-list`,
    },
    skip
  );

const getSubsidiaryCompanyList = (skip = {}) =>
  getRequest(
    {
      url: `/api/v1/system/site/get-subsidiary-company-list`,
    },
    skip
  );

const getAllSubsidiaryCompanyList = (skip = {}) =>
  getRequest(
    {
      url: `/api/v1/system/site/get-all-subsidiary-company-list`,
    },
    skip
  );

const getSiteManagementList = ({ form, pageable }) =>
  postRequest({
    url: '/api/v1/system/site/get-site-list',
    params: { ...pageable },
    data: { ...form },
  });

const getSiteManagementListMinor = ({ form, pageable }) =>
  postRequest({
    url: '/api/v1/system/site/get-site-list-minor',
    params: { ...pageable },
    data: { ...form },
  });

const getSiteManagement = (siteNumber) =>
  getRequest({
    url: `/api/v1/system/site/${siteNumber}`,
  });

const getSiteMemberCnt = (siteNumber) =>
  getRequest({
    url: `/api/v1/system/site/${siteNumber}/get-site-member-cnt`,
  });

const getSiteDisplay = (siteNumber) =>
  getRequest({
    url: `/api/v1/system/site/${siteNumber}/get-site-display`,
  });

const delSiteList = (data) =>
  deleteRequest({
    url: '/api/v1/system/site',
    data,
  });

const createSite = (data) =>
  postRequest({
    url: '/api/v1/system/site',
    data,
  });

const updateTempSite = (data) =>
  putRequest({
    url: '/api/v1/system/site/temp',
    data,
  });

const updateSettingRunningSite = (data) =>
  putRequest({
    url: '/api/v1/system/site',
    data,
  });
const updateSiteCustomerCenter = (data) =>
  putRequest({
    url: '/api/v1/system/site/put-customer-center',
    data,
  });
const updateSitePcLogoImage = (data) =>
  putRequest({
    url: '/api/v1/system/site/put-pc-logo-image',
    data,
  });
const updateSiteMoLogoImage = (data) =>
  putRequest({
    url: '/api/v1/system/site/put-mo-logo-image',
    data,
  });
const updateSiteStatus = (data) => {
  return putRequest({
    url: '/api/v1/system/site/put-site-status',
    data,
  });
};
const updateSiteResdEmail = (data) =>
  putRequest({
    url: '/api/v1/system/site/put-resd-email',
    data,
  });

export default {
  getSiteMgmtList,
  getAllSiteSimpleList,
  getSubsidiaryCompanyList,
  getAllSubsidiaryCompanyList,
  getSiteManagementList,
  getSiteManagementListMinor,
  getSiteManagement,
  getSiteMemberCnt,
  getSiteDisplay,
  delSiteList,
  createSite,
  updateTempSite,
  updateSettingRunningSite,
  updateSiteCustomerCenter,
  updateSitePcLogoImage,
  updateSiteMoLogoImage,
  updateSiteStatus,
  updateSiteResdEmail,
};
